import type { DetailData } from "../../../../../contexts/chat-log/chat-log-context";
import AssetCard from "./asset-card";

// ファイルアイコンの色を取得
function getIconColor(fileType: string): string {
  const type = (fileType || "").toUpperCase();
  if (type.includes("PDF")) return "#e74c3c";
  if (type.includes("DOC")) return "#2980b9";
  if (type.includes("XLS")) return "#27ae60";
  if (type.includes("PPT")) return "#e67e22";
  if (type.includes("ZIP") || type.includes("RAR")) return "#95a5a6";
  if (type.includes("TXT")) return "#34495e";
  return "#7f8c8d";
}

export default function File({
  file_path,
  file_name,
  file_type,
  thumbnail,
  asset_title,
  text,
  fullWidth,
}: Pick<DetailData, "file_path" | "file_name" | "file_type" | "thumbnail" | "asset_title" | "text"> & { fullWidth?: boolean }) {
  const displayFileName = file_name || "ファイル";

  // ファイルダウンロード処理
  const handleDownload = () => {
    if (!file_path) {
      console.error("[File] ファイルパスが指定されていません");
      return;
    }
    const link = document.createElement("a");
    link.href = file_path;
    link.download = file_name || "download";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AssetCard
      thumbnailUrl={thumbnail && thumbnail !== file_path ? thumbnail : undefined}
      alt={displayFileName}
      title={asset_title || displayFileName}
      description={text || undefined}
      onButtonClick={handleDownload}
      fullWidth={fullWidth}
      fallback={
        <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30 4H12C10.9 4 10 4.9 10 6V42C10 43.1 10.9 44 12 44H36C37.1 44 38 43.1 38 42V14L30 4Z"
            fill={getIconColor(file_type)}
            opacity="0.9"
          />
          <path d="M30 4V12C30 13.1 30.9 14 32 14H38L30 4Z" fill="#ffffff" opacity="0.7" />
        </svg>
      }
    />
  );
}
